<template>
  <div class='content'>

    <van-nav-bar title="填写信息" left-text="" right-text="" left-arrow @click-left="onClickLeft"
      @click-right="onClickRight" />

    <van-row>

      <van-col span="22" offset="1" style="">
        <van-col span="24">
          <van-col span="22" offset="" style="margin-top:0px;">
            <van-col span="24" class="text_scenicarea"> {{title}}</van-col>
          </van-col>
        </van-col>

        <van-col span="24">
          <van-col span="12" style="margin-top: 2px;">
            <van-col span="24" style=" font-size: 14px; color: #333333;font-weight: 500;"> 单价:￥{{title_price}}</van-col>
          </van-col>


        </van-col>


        <van-col span="24">
          <van-col span="22" offset="" style="margin-top:2px;margin-bottom:2px">

            <span style="color: gray; " @click="yuding()">预订须知
              <van-icon name="arrow" />
            </span>

          </van-col>
        </van-col>

        <van-col span="24">
          <van-col span="22" offset="" style="margin-top:0px;margin-bottom:2px">
            <span style="color: gray; " @click="yuding()">限制下单时间：{{title_time}}|每单数量：{{limitCountlist}}</span>

          </van-col>
        </van-col>



      </van-col>

    </van-row>
    <van-row>
      <van-col span="24" style="height: 10px;background-color: #F4F5F7;">
      </van-col>
    </van-row>

    <van-row type="flex">
      <van-col span="22" offset="1">
        <span style="height: 40px; display: block;">
          <van-col span="14" style="">
            <span
              style="display: inline-block; line-height:40px;height: 40px; font-size: 16px;color: #333333;font-weight: 600;">
              购买数量
            </span>
          </van-col>
          <van-col span="10" style="">
            <van-col span="8" align="center">
              <span style="display: inline-block; line-height:30px;height: 30px;">
                <van-button @click="jie()" :disabled="num===1" size="small" type="warning" icon="minus "></van-button>
              </span>
            </van-col>

            <van-col span="8" style="margin-left:0px; margin-top:10px; font-size: 14px; font-weight: 500;">
              <span style="display: inline-block; text-align: center; width: 100%;">{{num}}</span>
            </van-col>

            <van-col span="8" align="center">
              <span style="display: inline-block; line-height:30px;height: 30px;">
                <van-button @click="jia()" size="small" icon="plus" color="#FF4924FF"></van-button>
              </span>
            </van-col>

          </van-col>
        </span>


      </van-col>
    </van-row>
    <van-row>
      <van-col span="24" style="height: 10px;background-color: #F4F5F7;">
      </van-col>
    </van-row>


    <van-cell-group class="box">

      <van-field readonly required clickable name="calendar" v-model="timeDate" label="游玩日期" placeholder="点击选择日期"
        left-icon="underway-o" class='icon_color1' @click="showCalendar = true" />
      <van-calendar v-model="showCalendar" @confirm="onConfirm" />

      <van-field v-model="name"  clearable label="游客姓名" left-icon="manager" required placeholder="请输入姓名"
        class='icon_color1' />

      <van-field v-model="phone" clearable required label="手机号码" left-icon="phone-circle" placeholder="请输入电话号码"
        class='icon_color2' />

      <van-field v-model="ID_card"  v-if="hide_ID" clearable required label="身份证号" left-icon="debit-pay" placeholder="请输入身份证"
        class='icon_color2' />


      <van-field readonly required clickable left-icon="underway-o" label="预约时段" class='icon_color1' v-model="valuetime"
        v-if="hide_" placeholder="选择时间段" @focus="valuetime_=true" />
      <van-action-sheet v-model="valuetime_" :round="false" :actions="datatime" @select="onSelect">
      </van-action-sheet>

      <van-field v-if="hide" readonly v-model="Arealist" clearable required label="选择地区" left-icon="comment"
        placeholder="选择所在省市区" @click="toSelect" class='icon_color2' />
      <van-field v-if="hide" v-model="Area_" clearable required label="详细地址" left-icon="bars" placeholder="街道门牌,楼层房间号等"
        class='icon_color2' />
      <!-- <van-button type="info" @click="toSelect">请选择地址</van-button>-->

      <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
        <van-area @cancel="cancelFn" :area-list="areaList" @confirm="confirmFn"
          :columns-placeholder="['请选择', '请选择', '请选择']" title="选择所在省市区" />
      </van-popup>

    </van-cell-group>
    <van-popup v-model="show_yuding" closeable position="bottom" :style="{ height: '40%' }">

      <van-col span="24" style="margin-top: 40px;">
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#000000 ; font-size: 15px; font-weight: 800;">购票须知</span>
        </van-col>
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#000000 ; font-size: 15px; font-weight: 800;">{{title}}</span>
        </van-col>
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#000000 ; font-size: 15px; "> 价格说明</span>
        </van-col>
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#333333 ; font-size: 12px; ">单价: ￥{{price}}</span>
        </van-col>
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#333333 ; font-size: 12px; ">项目说明: {{detailsExplain}}</span>
        </van-col>

        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#000000 ; font-size: 15px; ">使用说明</span>
        </van-col>
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#333333 ; font-size: 12px; ">使用方法: {{reservationInstructions}}</span>
        </van-col>
        <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
          <span style="color:#333333 ; font-size: 12px; ">入园时间:{{enterMode}}</span>
        </van-col>
      </van-col>



    </van-popup>

    <van-row>
      <van-row>
        <van-col span="24" style="height: 10px;background-color: #F4F5F7;">
        </van-col>
      </van-row>

      <van-col span="22" offset="1" style="">
        <div class="box_visit_">

          <!--<p>
                <van-icon name="bars" />
              订单：{{order}}
              </p>-->

          <p v-if="hide_">
            可预约数：{{numlist_}}
          </p>
          <p v-if="hidelist">
            合计金额：{{total}}
          </p>

          <p v-if="hidelist">
            已选数量：{{numlist}}
          </p>

        </div>
      </van-col>
    </van-row>
    <!--   <van-row >
       <van-col span="24"  style="height: 10px;background-color: #F4F5F7;" >
       </van-col>
     </van-row> -->
    <!--<van-tabbar v-model="active">

		   <van-tabbar-item icon="home-o"><router-link to="/wx_ticketIndex" class="router" >购票首页</router-link></van-tabbar-item>
		   <van-tabbar-item icon="search"><router-link to="/wx_ticketOrder" class="router activerouter">我的订单</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_ticketUser" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>-->
    <!--<van-submit-bar  button-text="提交支付" :disabled="isDisable"  @submit="onSubmit">-->
    <van-submit-bar button-text="提交预约" :disabled="isDisable" @submit="onSubmit">
      <template>
        <div id="numlist">
          <van-row>
            <van-col span="24">
              <!-- <van-col span="10">
                <span style="margin-left: 3px; font-size: 16px;">数量:{{numlist}}</span>
              </van-col> -->
              <van-col span="24">
                <span class="total" style="font-size: 16px; color:#FF4924FF ;">合计:￥{{total}}</span>
              </van-col>
            </van-col>
          </van-row>


        </div>
      </template>
    </van-submit-bar>
  </div>
</template>

<script>
  import {
    areaList
  } from '@vant/area-data';
  export default {
    data() {
      return {
        title_time: '',
        show_yuding: false,
        hide_ID: false,
        num: 1,
        title_price: '',
        price: '',
        title_text: '',
        title: '',
        hide1: false,
        datatime: [],
        showtime: '',
        valuetime: '',
        valuetime_: false,
        limitCountlist: '',
        Area_: '',
        Arealist: '',
        show: false,
        areaList: areaList,
        searchResult: [],
        hidelist: false,
        hide_: false,
        numlist_: '0',
        isDisable: false,
        order: '',
        total: '',
        numlist: '1',
        totala: '',
        numlista: '',
        timeDate: '',
        currentDate: new Date(),
        phone: '',
        ID_card: '110101200001016316',

        name: "",
        message: '',
        isLoadingShow: true,
        hide: false,
        loading: false,
        finished: false,
        show: false,
        className: '',
        showCalendar: false,
        id: "",
        limitCount: '',
        timestart: '',
        timeend: '',
        enableid: '',
        enterMode: "",
        saleStartTime: "",
        saleEndTime: "",
        detailsExplain: "",
        reservationInstructions: "",
      }
    },
    mounted() {
      this.enable();
      this.time();
      //this.onLoadtime();
      // this.columns()
    },
    methods: {
      yuding() {
        this.show_yuding = true;
      },
      jia() {
        if (this.num === 99)
          return;
          this.num++;
          this.numlist = this.num;
          this.total = this.price * this.num
      },
      jie() {
        if (this.num === 1)
          return;
        this.num--;
        this.numlist = this.num;
        this.total = this.price * this.num
      },

      onSelect(item) {

        this.valuetime_ = false;
        this.valuetime = item.name;
        this.id = item.id;

        let enable_id = this.$route.query.enable_id;
        if (enable_id == 1) {
          this.timestart = item.timestart;
          this.timeend = item.timeend;
          // this.numlist_= item.limitCount;
          this.onLoadtime();

        } else {
          this.timestart = '00:00:01';
          this.timeend = '23:59:59';
        }

        // this.onLoadtime();
      },
      enable() {
        let isRealName = this.$route.query.isRealName;

        if(isRealName==1){
          this.hide_ID=true;
          this.ID_card='';
        } else{
          this.hide_ID=false;

        }

        let enable_id = this.$route.query.enable_id;
        this.limitCountlist  = this.$route.query.limitCount;

         if(this.limitCountlist=="0"){
           this.limitCountlist="无";
         }
        if (enable_id == 1) {
          this.hide_ = true
          this.columns()

        } else {
          this.hide_ = false;
        }
      },
      columns() {
        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let ticketTypeID = this.$route.query.tickettype;
        this.$axios({
            url: "/api/appointmentConfig",
            method: "get",
            params: {
              pageItems: 999, //每页显示的条数
              pageNumber: 1, //页数
              ticketTypeID: ticketTypeID,
            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            console.log(res.data)
            var data = res.data[0];
            this.datatime = [];
            for (const i in data) {
              let start = data[i].startPeriod.substring(0, 2) + ':' + data[i].startPeriod.substring(2, 4);
              let end = data[i].endPeriod.substring(0, 2) + ':' + data[i].endPeriod.substring(2, 4);
              let name = start + "-" + end;
              this.datatime.push({
                id: data[i].id,
                name: name,
                timestart: start,
                timeend: end,
                limitCount: data[i].limitCount,

              });
            }


          })
          .catch(err => {
            console.log(err);
          });

      },

      toSelect() {
        this.show = true;
      },
      confirmFn(value) {
        this.show = false;
        let a1 = value[0].name;
        if (a1 == "") {
          return
        }
        let a2 = value[1].name;
        if (a2 == "") {
          return
        }
        let a3 = value[2].name;
        if (a3 == "") {
          return
        }
        this.Arealist = a1 + a2 + a3;
      },
      cancelFn() {
        this.show = false;
      },

      onLoadtime() {
        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let time1 = this.timeDate + ' ' + this.timestart;
        let time2 = this.timeDate + ' ' + this.timeend;
        let id = this.id;
        let ticketTypeID = this.$route.query.tickettype;
        this.$axios({
            url: "/api/sell/getRemainTicketCount",
            method: "post",
            data: {
              ticketTypeID: ticketTypeID,
              startTime: time1,
              endTime: time2,
              appointmentID: id,
            },
           headers: {
             "authorization": token,
             "Content-Type": "application/json; charset=utf-8"
           }
          })
          .then(res => {
            console.log(res.data)
            this.numlist_ = res.data.remainTicketCount;
          })
          .catch(err => {
            console.log(err);
            this.$notify({
              type: 'warning',
              message: '获取不到可预约人数'
            });

          });


      },
      onLoad() {
        this.loading = false;
        this.finished = true;

      },
      onClickLeft() {
        this.$router.push({
          path: "/wx_ticketList"
        });
      },
      onClickRight() {},

      // 确认
      onSubmit() {

        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let scenicAreaID = storage.getItem("scenicAreaID");
        this.ticketlist = [];
        this.isDisable = true;
        setTimeout(() => {
          this.isDisable = false
        }, 3000)
        if (this.saleStartTime !== "") {

          if (this.timeDate >= this.saleStartTime && this.timeDate <= this.saleEndTime) {} else {
            this.$notify({
              type: 'warning',
              message: '你选择的时间不在下单时间范围内,请注意查看下单的限制时间'
            });
            return;
          }
        }
        let name = this.name;
        let phone = this.phone;
        let ID_card = this.ID_card;
        let limitCountlist  = this.$route.query.limitCount;

        console.log(limitCountlist)
        if(limitCountlist==0){
          limitCountlist=999;
        }
        if (this.num > limitCountlist) {
          this.$notify({
            type: 'warning',
            message: '下单数量大于限购数量'
          });
          return;
        }


        if (name == "") {
          this.$notify({
            type: 'warning',
            message: '请输入游客姓名'
          });
          return;
        }
        if (name.length > 12) {
          this.$notify({
            type: 'warning',
            message: '输入姓名不能大于12个字符'
          });
          return;
        }
        if (phone == "") {
          this.$notify({
            type: 'warning',
            message: '请输入电话号码'
          });
          return;
        }
        if ((!(/^[1][345789]\d{9}$/).test(phone) || !(/^[1-9]\d*$/).test(phone) || phone.length !== 11)) {
          this.$notify({
            type: 'warning',
            message: '电话号码不符合规格'
          });
          return;
        }

        if (ID_card == "") {
          this.$notify({
            type: 'warning',
            message: '请输入身份证号码'
          });
          return;
        }


        let Arealist = this.Arealist;
        // if(Arealist ==""){
        // 		this.$notify({ type: 'warning', message: '请选择地区' });
        //      return;
        // }
        var Area = this.Area_;
        let valuetime = this.valuetime;
        // if(Area ==""){
        //	this.$notify({ type: 'warning', message: '请填写详细地址' });
        //     return;
        // }
        let returnParam = this.ID_cardlist(ID_card);
        let isPass = returnParam.isPass;
        if (isPass == false) {
          this.$notify({
            type: 'warning',
            message: '请输入正确的身份证号码'
          });
          return;
        }
        let numlist_ = this.numlist_;
        let people = this.numlist;

        var nowDate = new Date();
        var year = nowDate.getFullYear();
        var month = nowDate.getMonth() < 9 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
        var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        var timelist = year + "-" + month + "-" + day;
        let hour = nowDate.getHours(); // 时
        hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
        let minute = nowDate.getMinutes(); // 分
        minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
        let timemin = hour + ":" + minute;
        let enable_id = this.$route.query.enable_id;


        if (enable_id == 1) {

          if (valuetime == "") {
            this.$notify({
              type: 'warning',
              message: '请选择预约时段'
            });
            return;
          }

          if (timelist == this.timeDate) {
            if (this.timeend < timemin) {
              this.$notify({
                type: 'warning',
                message: '预约的时间段已不在有效期内'
              });
              return;
            }
          }
          if (people > numlist_) {
            this.$notify({
              type: 'warning',
              message: '预约人数的名额不够,请重新购票'
            });
            return;
          }
          var appointmentStartTime = this.timeDate + ' ' + this.timestart;
          var appointmentEndTime = this.timeDate + ' ' + this.timeend;

        } else {
          this.timestart = '00:00:01';
          this.timeend = '23:59:59';
          var appointmentStartTime = this.timeDate + ' ' + this.timestart;
          var appointmentEndTime = "";
        }
        let total = Number(this.total);
        let openid = storage.getItem("openid")
        if (openid == null || openid == "null" || openid == "undefined" || openid == undefined || openid == "") {
          alert("openID获取失败，请退出公众号在重新进入");
          return
        }
        let touristResidence = this.Arealist + this.Area_;
        let thta = this;

        let ticketArray = []
        ticketArray.push({
          ticketTypeID: this.$route.query.ticketTypeID,
          ticketCount: this.num
        })
        let ticketTypeID = this.$route.query.ticketTypeID

        var payWay = '9';
        var touristSex = '0';
        var ticketParams = {
          touristInfo: {
            touristName: name,
            touristMobile: phone,
            touristResidence: touristResidence,
            touristSex: touristSex,
            touristPhoto: '',
            touristCompany: '',
          },
          ticketArray: ticketArray,
          appointmentStartTime: appointmentStartTime,
          appointmentEndTime: appointmentEndTime,
        }

        if (total == 0) {

          if (people > 0) {
            this.$axios({
                url: "/api/sell/wxSubmitOrder",
                method: "post",
                data: {
                  scenicAreaID: scenicAreaID,
                  discountAmount: '',
                  payWay: payWay,
                  openid: openid,
                  orderAmount: total,
                  ticketTypeID: ticketTypeID,
                  touristIDCardNum: ID_card, //身份证
                  ticketParams: ticketParams,

                },
               headers: {
                 "authorization": token,
                 "Content-Type": "application/json; charset=utf-8"
               }
              })
              .then(res => {
                console.log(res.data)
                if (res.data.result_msg == "禁止来自中高风险地区通行") {
                  this.$notify({
                    type: 'warning',
                    message: '身份证属于风险地区不能预约'
                  });
                  return;
                }

                let data = res.data.JSAPI_result;
                if (res.data.result_msg == "") {

                  this.order_list(data.orderID);

                }
              })
          }


        } else {

          this.$axios({
              url: "/api/sell/wxSubmitOrder",
              method: "post",
              data: {
                scenicAreaID: scenicAreaID,
                discountAmount: '',
                payWay: payWay,
                openid: openid,
                orderAmount: total,
                ticketTypeID: ticketTypeID,
                touristIDCardNum: ID_card, //身份证
                ticketParams: ticketParams,

              },
              headers: {
                "Content-Type": "application/json; charset=utf-8"
              }
            })
            .then(res => {
              if (res.data.result_msg == "禁止来自中高风险地区通行") {
                this.$notify({
                  type: 'warning',
                  message: '身份证属于风险地区不能预约'
                });
                return;
              }

              let datalist = res.data;
              let data = res.data.JSAPI_result;
              if (datalist.result_msg == '失败') {
                alert("支付失败，请重新进入系统购票");
              } else {
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp,
                      data.nonceStr, data.prepayID, data.paySign, data.orderID), false);
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data
                      .nonceStr, data.prepayID, data.paySign, data.orderID));
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data
                      .nonceStr, data.prepayID, data.paySign, data.orderID));
                  }
                } else {

                  this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data
                    .orderID);
                }
              }
            })
            .catch(err => {
              console.log(err);
              this.$notify({
                type: 'warning',
                message: '调取支付失败'
              });

            });
        }
      },
      onBridgeReady(appid, timeStamp, nonceStr, prepay_id, paySign, orderID) {
        let thta = this;
        let storage = window.sessionStorage;
       
        let token = storage.getItem("token")
        let openid = storage.getItem("openid")
        let ticketArray = thta.$route.query.ticketArray
        let ID_card = thta.ID_card;
        let name = thta.name;
        let time = '';
        let phone = thta.phone;
        let total = thta.total;
        let flag = '1';
        let payWay = "9";
        /*var nowDate = new Date();
	            var year = nowDate.getFullYear();
	            var month = nowDate.getMonth() < 9 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
	            var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
	            var timelist = year + "-" + month + "-" +   day;

				   if(time==timelist){
				 		 time = thta.timeDate;
				 	}else{
				 		 time = thta.timeDate+" " + "00:00:00";
				 	}*/
        let appointmentStartTime = this.timeDate + ' ' + this.timestart;
        let appointmentEndTime = this.timeDate + ' ' + this.timeend;
        let touristResidence = this.Arealist + this.Area_;

        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": appid,
            "timeStamp": timeStamp,
            "nonceStr": nonceStr,
            "package": "prepay_id=" + prepay_id + "",
            "signType": "MD5",
            "paySign": paySign
          },
          function(res) {
            let temp = res.err_msg;
            if (temp.indexOf('ok') > -1) {
              thta.$axios({
                  url: "/api/sell/wxConfirmOrder",
                  method: "post",
                  data: {
                    payWay: payWay,
                    flag: flag,
                    openid: openid,
                    orderID: orderID,
                    orderAmount: total,

                  },
                 headers: {
                   "authorization": token,
                   "Content-Type": "application/json; charset=utf-8"
                 }
                })
                .then(res => {

                  if (res.data.orderID !== "") {
                    /*  this.$message({
                        showClose: true,
                        message: "success,支付成功",
                        type: "success",
                        duration: 5000
                      });*/
                    //alert("支付成功");
                    //window.location.href = '/wx_ticketOrderlist';
                    thta.$router.push({
                      path: "/wx_ticketOrderlist"
                    });
                  } else {
                    /* this.$message({
                       showClose: true,
                       message: res.data.errMsg,
                       type: "error",
                       duration: 5000
                     });*/
                    alert("支付失败");
                  }
                })
                .catch(err => {
                  console.log(err);
                  alert("支付失败");
                });
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
          });
      },
      order_list(orderID) {
        let thta = this;
        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let openid = storage.getItem("openid")
        let ticketArray = thta.$route.query.ticketArray
        let ID_card = thta.ID_card;
        let name = thta.name;
        let time = '';
        let phone = thta.phone;
        let total = thta.total;
        let flag = '1';
        let payWay = "9";
        /*let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = nowDate.getMonth() < 9 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
            let day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
            let timelist = year + "-" + month + "-" + day;*/
        let touristResidence = this.Arealist + this.Area_;
        let appointmentStartTime = this.timeDate + ' ' + this.timestart;
        let appointmentEndTime = this.timeDate + ' ' + this.timeend;
        //ticketStartTime:time,//游玩时间
        this.$axios({
            url: "/api/sell/wxConfirmOrder",
            method: "post",
            data: {
              payWay: payWay,
              openid: openid,
              orderID: orderID,
              orderAmount: total,
            },
           headers: {
             "authorization": token,
             "Content-Type": "application/json; charset=utf-8"
           }
          }).then(res => {
            console.log(res.data);
            if (res.data.orderID !== "") {
              alert("预约成功");
              this.$router.push({
                path: "/wx_ticketOrderlist"
              });
            } else {
              /* this.$message({
                 showClose: true,
                 message: res.data.errMsg,
                 type: "error",
                 duration: 5000
               });*/
              alert("预约失败");
            }
          })
          .catch(err => {
            console.log(err);

            alert("数据连接异常，预约失败 ，将回到购票页面");

            setTimeout(function() {

              this.$router.push({
                path: "/wx_ticketList"
              });
            }, 2000);


          });

      },

      time() {
        this.timeDate = this.dateFormat();
        let storage=window.sessionStorage;
        let token = storage.getItem("token")
        let openid = storage.getItem("openid")

        this.title = this.$route.query.ticketTypeName;
        console.log(this.title)
        this.title_text = this.$route.query.isAppointmentEnable;
        this.title_price = this.$route.query.price;
        this.price = this.$route.query.price;
        this.total = this.price * this.num

        this.enterMode = this.$route.query.enterMode;
        this.detailsExplain = this.$route.query.detailsExplain;
        this.reservationInstructions = this.$route.query.reservationInstructions;
        this.saleStartTime = this.$route.query.saleStartTime.substring(0, 10);
        this.saleEndTime = this.$route.query.saleEndTime.substring(0, 10);

        let saleStartTime = this.$route.query.saleStartTime;
        let saleEndTime = this.$route.query.saleEndTime;
        if (saleStartTime == '') {
          this.title_time = "无"
        } else {
          this.title_time = saleStartTime.substring(0, 10) + "-" + saleEndTime.substring(0, 10);
        }

        /*      ticketTypeName:ticketTypeName,
              ticketTypeID: ticketTypeID,
              isAppointmentEnable:isAppointmentEnable,
              isRefundCheck:isRefundCheck,
              price:price,
           */

      },
      onConfirm(date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        this.timeDate = year + "-" + month + "-" + day
        this.showCalendar = false;
        this.valuetime = "";
        this.numlist_ = "";
        //  this.onLoadtime()
      },
      dateFormat() { //获取当前时间
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
        // var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
        return year + "-" + month + "-" + day
      },
      ID_cardlist(ID_card) {
        //身份证号前两位代表区域
        var city = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江 ",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北 ",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏 ",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外 "
        };
        //身份证格式正则表达式
        var idCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
        var errorMess = ""; //错误提示信息
        var isPass = true; //身份证验证是否通过（true通过、false未通过）

        //如果身份证不满足格式正则表达式
        if (!ID_card || !idCardReg.test(ID_card)) {
          errorMess = "您输入的身份证号格式有误！";
          isPass = false;
        }

        //区域数组中不包含需验证的身份证前两位
        else if (!city[ID_card.substr(0, 2)]) {
          errorMess = "您输入的身份证地址编码有误！";
          isPass = false;
        } else {
          //18位身份证需要验证最后一位校验位
          if (ID_card.length == 18) {
            ID_card = ID_card.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
              ai = ID_card[i];
              wi = factor[i];
              sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] !== ID_card[17]) {
              errorMess = "18身份证最后一位校验位验证有误！";
              isPass = false;
            }
          }
        }
        var returnParam = {
          'errorMess': errorMess,
          'isPass': isPass
        }
        return returnParam;
      },
      showPopup() {
        this.show = true
        this.isLoadingShow = true
        setTimeout(() => {
          this.isLoadingShow = false
        }, 500)
      },


    }
  }
</script>

<style>
  .text_remark {
    font-size: 12px;
    background-color: #FEE6E5FF;
    color: #CF1322FF;
    padding: 0 3px;
  }

  .text_scenicarea {
    font-weight: 600;

    font-size: 14px;
    margin-top: 6px;
    color: #333333;

  }

  .title_ {
    display: inline-block;
    background-color: #FFFFFF;

  }

  #numlist span .button_ {
    display: inline-block;
    width: 40px;
    height: 48px;
    line-height: 48px;
    font-size: 13px;
    text-align: center;
  }

  #numlist span {
    display: inline-block;
    width: 68px;
    height: 48px;
    line-height: 48px;
    font-size: 13px;
    text-align: center;
  }

  #numlist .total {
    text-align: left;
    width: 108px;
  }

  .icon_color1 i {
    color: #1989fa;
  }

  .icon_color2 i {
    color: #19c160;
  }

  .icon_color3 i {
    color: #07c160;
  }

  .icon_color4 i {
    color: #4fc08d;
  }

  .icon_color5 i {
    color: #2989fa;
  }

  .box_visit_ {

    margin-top: 30px;

    height: 60px;
    margin-bottom: 10px;
    border: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketOrder.vue